import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GAIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GA" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#40A8FF"
        fillRule="evenodd"
        d="M0 8h16v4H0V8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M0 4h16v4H0V4Z"
        clipRule="evenodd"
      />
      <Path
        fill="#73BE4A"
        fillRule="evenodd"
        d="M0 0h16v4H0V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
